import { PROJECTNAMEALIAS, NFTAPIBASENAME,PAYBITOAPIBASENAME } from './Setup'
import Swal from 'sweetalert2';
import axios from "axios";
import NFTMarketplace from './Marketplace.json';
import { ethers } from "ethers";
import web3 from "web3"

//const axios = require("axios");
//import { useNavigate } from "react-router-dom";
//const navigate = useNavigate();

/* Method defination for api call */
export const callAPI = (type, url, payload, isAuthRequired) => {
  let apiHeaders = {}
  if (isAuthRequired) {
    let session = JSON.parse(localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session'));
    apiHeaders['headers'] = {
      "Content-Type": "application/json",
      "Authorization": "bearer " + session.token,
    }
  } else {
    apiHeaders['headers'] = {
      "Content-Type": "application/json",
    }
  }
  let response = '';
  if (type.toLowerCase() == 'post') {
    response = axios.post(url, JSON.stringify(payload), apiHeaders);
  } else {
    response = axios.get(url, apiHeaders);
  }
  return response;
}



/* Method defination for seting a data as session in local storage */

export const setSessionData = (key, value) => {
  let session = {};
  
  console.log(key, value,localStorage.getItem('nftBrokerExchangeName')+'_nft_');
  if (
    localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session') != undefined &&
    localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session') != null &&
    localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session') != 'undefined' &&
    localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session') != 'null'
  ) {
    session = localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session');
    session = JSON.parse(session);
  }

  session[key] = value;
  localStorage.setItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session', JSON.stringify(session));
}
/* Method defination for geting all data from session in local storage */

export const getAllSessionData = () => {
  let session = localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session');
  session = JSON.parse(session);
  return session;
}

/* Show toast message */
export const showToast = (type, message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 7000,
    timerProgressBar: false,
    onOpen: (toast) => {
      //toast.addEventListener('mouseenter', Swal.stopTimer)
      //toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  Toast.fire({
    icon: type,
    title: message
  })
}

/*** method defination for confirm message  ***/
export const showConfirm = (title, text, type, callback) => {
  Swal.fire({
    title: title,
    text: text,
    icon: type,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes'
  }).then((result) => {
    if (result.value) {
      callback();
    }
  })
}
/*** method defination for confirm message  ***/
export const showPopupWithImage = (title, text, image) => {
  Swal.fire({
    title: title,
    text: text,
    imageUrl: image,
    imageWidth: 400,
    imageHeight: 200,
    imageAlt: "nft"
  });
}




/* Method defination for confirm purchase details */
export const showConfirmPurchase = (name, image) => {
  Swal.fire({
    title: "Congratulations",
    text: "You have successfully bought " + name,
    imageUrl: image,
    imageWidth: 200,
    imageHeight: 200,
    imageAlt: "NFT image",
    allowOutsideClick: false,
    showCancelButton: false,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Explore More"
  });
}

/***  funtion defination for showing http error ***/
export const showHttpError = (error) => {
  if (error.response != undefined) {
    var code = error.response.status;
    // console.log('error status is:',error.response.status)
    // alert(error)
    // alert(code)
    //console.log('error',(error.toString()).indexOf('401'))
    /* if((error.toString()).indexOf('401')!= -1) {
      showToast('error','Authentication Failed')
      handleLogout();
    } */
    //console.log('error code ',error.response.code)

    if (code == '401' || (error.toString()).indexOf('401') != -1) {
      showToast('error', 'Session Timeout')
      handleLogout();
    } else if (code == '403') {
      showToast('error', '403 error')
      handleLogout();
    } else if (code == '404' || code == '403' || code == '400') {
      showToast('error', 'Failed to connect with the server');
    } else if (code == '500') {
      showToast('error', 'Internal Server Error');
    } else {
      showToast('error', code + ' : Technical Error');
    }
  } else {
    showToast('error' + error)
  }
}
/* Method defination for logout */
export const handleLogout = () => {
  localStorage.removeItem(PROJECTNAMEALIAS + "meta_mask_sign")
  localStorage.removeItem(PROJECTNAMEALIAS + 'session');
  let currentUrl = window.location.href
  let urlArr = currentUrl.split('/nft-marketplace/');
  console.log(urlArr)
  window.location.href = urlArr[0] + '/nft-marketplace/'
  setTimeout(() => {
    window.location.reload();
  }, 1000);
};

/* Method defination for sending email otp */
export const sendOtpInEmail = (payload, purpose) => {
  return callAPI('POST', NFTAPIBASENAME + '/adminAccess/SendOTP/' + purpose, payload, false)
}
/* Method defination for sending phone otp */
export const sendOtpInPhone = (payload, purpose) => {
  return callAPI('POST', NFTAPIBASENAME + '/adminAccess/SendPhoneOTP/' + purpose, payload, false)
}

/* Method defination for checking if user is logged in */
export const checkIfUserIsLoggedIn = () => {
  let isLoggedIn = false
  if (getAllSessionData() != undefined && getAllSessionData() != null && getAllSessionData() != 'undefined') {
    isLoggedIn = true
  } else {
    isLoggedIn = false
  }
  return isLoggedIn;
}

/* Method defination for cart manipulation */
export const handleCartManipulation = (item, action) => {
  let cart = [];
  if (localStorage.getItem(PROJECTNAMEALIAS + 'cart') != undefined && localStorage.getItem(PROJECTNAMEALIAS + 'cart') != 'undefined' && localStorage.getItem(PROJECTNAMEALIAS + 'cart') != null) {
    cart = JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart'));
  } else {
    cart = [];
  }
  console.log('NFTITEM', item)
  if (action == 'add') {
    let obj = {
      id: item.nftId,
      name: item.nftName,
      price: item.nftPrice,
      collectionName: item.nftCollectionName,
      image: item.nftFileName,
      currencyCode: item.networkName
    }
    cart.push(obj)
    showToast('success', 'Item has been added to your cart.')
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    window.location.reload();
    //console.log(getAllSessionData())
    if (getAllSessionData() != undefined && getAllSessionData() != null) {
      manipulateCartAfterLoggedIn(item.nftId, 'add')
    }
  } else if (action == 'delete') {
    for (let i = 0; i < cart.length; i++) {
      console.log(cart[i].id, item.id)
      console.log('CART ITEM ID:', item.id)
      if (cart[i].id == item.id) {
        console.log('card id matched with item id')
        cart.splice(i, 1);
        showToast('success', "item has been removed from your cart.")
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        if (getAllSessionData() != undefined && getAllSessionData() != null) {
          manipulateCartAfterLoggedIn(item.id, 'delete')
        }
      }
      break;
    }
  }

  localStorage.setItem(PROJECTNAMEALIAS + 'cart', JSON.stringify(cart))
  getCartCount();


}
/* Method defination for cart count */
export const getCartCount = () => {
  let count = 0
  let cart = []
  if (localStorage.getItem(PROJECTNAMEALIAS + 'cart') != undefined && localStorage.getItem(PROJECTNAMEALIAS + 'cart') != 'undefined' && localStorage.getItem(PROJECTNAMEALIAS + 'cart') != null) {
    cart = JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart'));
  }
  count = cart.length;
  return count;

}


/* Method defination for manipulate cart after logged in */
export const manipulateCartAfterLoggedIn = (id, action) => {
  let payload = { "cartItem": { "userUuid": getAllSessionData().uuid, "nftId": id } }
  let url = ''
  if (action == 'add') {
    url = NFTAPIBASENAME + '/nft/market/addCartItem'
  } else if (action == 'delete') {
    url = NFTAPIBASENAME + '/nft/market/deleteCartItem'
  }
  callAPI('post', url, payload, true).then((res) => {
    let response = res.data;
    console.log(response);
    if (response.error.error_data != 0) {
      showToast('error', response.error.error_msg)
    } else {
      getCartDataAfterLoggedIn();
    }

  }, (error) => {
    showHttpError(error)
  })
}

/* Method defination for get all cart data after logged in */
export const getCartDataAfterLoggedIn = () => {
  let payload = {}
  callAPI('get', NFTAPIBASENAME + '/nft/market/getUserCartDetails?uuid=' + getAllSessionData().uuid, payload, true).then((res) => {
    let response = res.data;
    console.log(response);
    if (response.error.error_data != 0) {
      showToast('error', response.error.error_msg)
    } else {
      if (response.cartItems != undefined && response.cartItem != null) {
        let cart = [];
        let cartItems = response.cartItems
        for (let i = 0; i < cartItems.length; i++) {
          let obj = {
            id: cartItems[i].nftId,
            name: cartItems[i].nftName,
            price: cartItems[i].price,
            collectionName: cartItems[i].nftCollectionName,
            image: cartItems[i].nftFileName,
            currencyCode: cartItems[i].currencyCode
          }
          cart.push(obj);
        }
        localStorage.setItem(PROJECTNAMEALIAS + 'cart', JSON.stringify(cart))
      }
    }

  }, (error) => {
    showHttpError(error)
  })
}
/* Method defination for add to favorite */
export const addToFavorite = (entityId, callback) => {
  if (getAllSessionData() != null && getAllSessionData() != undefined) {

    let payload = { "userUuid": getAllSessionData().uuid, "entityId": entityId }
    callAPI('post', NFTAPIBASENAME + '/nft/market/addToFavourite', payload, true).then((res) => {
      let response = res.data;
      console.log(response);
      if (response.error.error_data != 0) {
        showToast('error', response.error.error_msg)
      } else {
        showToast('success', 'Added to favorites')
        callback();
      }

    }, (error) => {
      showHttpError(error)
    })
  } else {
    showToast('error', 'Please login to continue')
  }
}
/* Method defination for remove favorite */
export const removeFromFavorite = (entityId, callback) => {
  if (getAllSessionData() != null && getAllSessionData() != undefined) {

    let payload = { "userUuid": getAllSessionData().uuid, "entityId": entityId }
    callAPI('post', NFTAPIBASENAME + '/nft/market/removeFromFavourite', payload, true).then((res) => {
      let response = res.data;
      console.log(response);
      if (response.error.error_data != 0) {
        showToast('error', response.error.error_msg)
      } else {
        showToast('success', 'Removed from favorites')
        callback();
      }

    }, (error) => {
      showHttpError(error)
    })
  } else {
    showToast('error', 'Please login to continue')
  }
}

/* Method defination for if nft Id is available in cart */
export const isNftAddedToCart = (nftId) => {
  let cart = JSON.parse(localStorage.getItem(PROJECTNAMEALIAS + 'cart'));
  console.log('cart count:', cart)

  if (cart === null || cart === 'null') {
    // localStorage.setItem(PROJECTNAMEALIAS + 'cart',[])
    // // console.log('cart is null')
  } else {
    let status = false
    for (let i = 0; i < cart.length; i++) {
      if (nftId == cart[i].id) {
        status = true;
        break;
      }
    }
    return status;
  }
}

/* Method defination for get collection details */
export const getCollectionDetailsFromLibrary = (id) => {
  let payload = { "entityId": id }
  let apiHeaders = {}
  apiHeaders['headers'] = {
    "Content-Type": "application/json",
  }

  return axios.post(NFTAPIBASENAME + '/nft/market/public/getCollectionDetails', JSON.stringify(payload), apiHeaders)

}

/* Method defination for price validation */
export const priceValidation = (value, type) => {
  let status = false
  if (type == 'creatorearning') {
    if (parseFloat(value) > 0 && parseFloat(value) <= 100) {
      status = true
    }
  } else if (type == 'floorprice') {
    console.log(value.length)
    if (value.length <= 8) {

      status = true
    }
  }
  return status
}

// Returns the MetaMask provider specifically, bypassing Phantom and other EVM wallets.
// Uses EIP-6963 (modern wallet discovery) first — this prevents Phantom from showing
// its "Which extension?" picker. Falls back to the legacy providers[] array approach.
export const getMetaMaskProvider = () => {
  return new Promise((resolve) => {
    let resolved = false;

    const handleAnnounce = (event) => {
      const { info, provider } = event.detail;
      // MetaMask's official EIP-6963 RDNS identifier
      if (!resolved && info.rdns === 'io.metamask') {
        resolved = true;
        window.removeEventListener('eip6963:announceProvider', handleAnnounce);
        resolve(provider);
      }
    };

    window.addEventListener('eip6963:announceProvider', handleAnnounce);
    // Ask all installed wallets to announce themselves
    window.dispatchEvent(new Event('eip6963:requestProvider'));

    // Give wallets 300ms to respond, then fall back to legacy approach
    setTimeout(() => {
      window.removeEventListener('eip6963:announceProvider', handleAnnounce);
      if (!resolved) {
        resolved = true;
        if (window.ethereum?.providers?.length) {
          // Multiple wallets: find MetaMask, exclude Phantom
          const mm = window.ethereum.providers.find(p => p.isMetaMask && !p.isPhantom);
          resolve(mm || null);
        } else if (window.ethereum?.isMetaMask && !window.ethereum?.isPhantom) {
          resolve(window.ethereum);
        } else {
          resolve(null);
        }
      }
    }, 300);
  });
}

// autoSwitch = true  → show toasts + trigger MetaMask network-switch popup (use for buy/sell/bid flows)
// autoSwitch = false → silent mode: no toasts, no popups; returns null if not on mainnet (use for public pages)
export const getBlockChainContract = async (autoSwitch = true) => {
  try {
    const provider = await getMetaMaskProvider();
    if (!provider) {
      if (autoSwitch) {
        showToast('error', 'MetaMask is not installed or not enabled in this browser/incognito mode.');
      }
      return null;
    }

    const MAINNET_CHAIN_ID = '0x1'; // Ethereum Mainnet

    const currentChainId = await provider.request({ method: 'eth_chainId' });
    console.log('Current chainId:', currentChainId);

    if (currentChainId !== MAINNET_CHAIN_ID) {
      if (!autoSwitch) {
        // Silent mode — don't open any popup, just bail out
        console.log('Not on mainnet; skipping contract (silent mode).');
        return null;
      }
      try {
        showToast('info', 'Switching MetaMask to Ethereum Mainnet...');
        await provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: MAINNET_CHAIN_ID }],
        });
      } catch (switchError) {
        if (switchError.code === 4001) {
          // User intentionally rejected the network switch — don't show an error
          console.log('User rejected MetaMask network switch.');
        } else {
          showToast('error', 'Please switch MetaMask to Ethereum Mainnet to continue.');
          console.log('Network switch error:', switchError);
        }
        return null;
      }
    }

    const Web3 = new web3(provider);
    const networkId = await Web3.eth.net.getId();
    const networkData = NFTMarketplace.networks[networkId];
    console.log('Network Data', networkId, NFTMarketplace.networks)
    if (networkData) {
      const abi = NFTMarketplace.abi;
      const address = networkData.address;
      const contract = new Web3.eth.Contract(abi, address);
      return contract
    } else {
      if (autoSwitch) {
        showToast('error', 'Smart contract not deployed to detected network.');
      }
      return null;
    }
  } catch (error) {
    if (autoSwitch) {
      showToast('error', 'Error loading blockchain data, make sure Meta Mask is installed and connected');
    }
    console.log(error)
    return null;
  }
}
export const fetchCommissionRate = async () => {
  let contract = await getBlockChainContract();
  try {
    const commission = await contract.methods.getCommissionRate().call();
    console.log('Commission..', commission);
    return (commission.toString());
  } catch (error) {
    showToast('error', 'Error fetching commission rate' + error);
    return 0;
  }
};

export const isUserSessionActive = async() => {
  try {
    let apiHeaders = {};
    let session = JSON.parse(localStorage.getItem(localStorage.getItem('nftBrokerExchangeName')+'_nft_' + 'session'));
    apiHeaders['headers'] = {
      "Content-Type": "application/json",
      "Authorization": "bearer " + session.token,
    }
    const response = await axios.post(PAYBITOAPIBASENAME + '/user/GetUserDetails', JSON.stringify({uuid : session.uuid }), apiHeaders);
    // If no 401, treat as success
    return { isActive: true, data: response.data };
  } catch (error) {
    if (error.response && error.response.status === 401) {
      // Handle 401 error
      return { isActive: false, error: 'Unauthorized access (401)' };
    }
    // Handle other errors
    return { isActive: false, error: error.message };
  }
}

